import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip
} from '@material-ui/core';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import { TypographyProps } from '@material-ui/core/Typography';
import { Close } from '@material-ui/icons';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    titleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      borderBottom: `1px solid ${theme.palette.text.primary}`,
      alignItems: 'center',
      height: '4rem'
    }
  });

interface IMyDialogProps extends TypographyProps {
  open: boolean;
  onClose: () => void;
  title: string;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

function MyDialog(props: IMyDialogProps & WithStyles<typeof styles>) {
  return (
    <Dialog
      disableBackdropClick={true}
      open={props.open}
      onClose={props.onClose}
      maxWidth={props.maxWidth}
      className={props.classes.root}
    >
      <div className={props.classes.titleWrapper}>
        <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
        <Tooltip title={'Close'}>
          <IconButton style={{ marginRight: '1rem' }} onClick={props.onClose}>
            <Close />
          </IconButton>
        </Tooltip>
      </div>
      <DialogContent style={{ padding: '1.5rem' }}>
        {props.children}
      </DialogContent>
    </Dialog>
  );
}

export default withStyles(styles)(MyDialog);
